const data = {};
let isLocalStorageSupport = true;

const prefix = key => `frontend-${key}`;

export const getLanguageLocalStorage = () => prefix('i18nextLng');

export const detectLocalStorageSupport = () => {
	try {
		window.localStorage.setItem('test', '1');
		window.localStorage.removeItem('test');
	} catch (e) {
		console.warn('Does not support localStorage', e);
		isLocalStorageSupport = false;
	}
};

const setItem = (key, value) => {
	const prefixKey = prefix(key);

	if (isLocalStorageSupport) {
		window.localStorage.setItem(prefixKey, value);
		return;
	}

	data[prefixKey] = value;
};

const getItem = key => {
	const prefixKey = prefix(key);

	if (isLocalStorageSupport) {
		return window.localStorage.getItem(prefixKey);
	}

	if (Object.hasOwnProperty.call(data, prefixKey)) {
		return data[prefixKey];
	}

	return null;
};

const removeItem = key => {
	const prefixKey = prefix(key);

	if (isLocalStorageSupport) {
		window.localStorage.removeItem(prefixKey);
		return;
	}

	if (Object.hasOwnProperty.call(data, prefixKey)) {
		delete data[prefixKey];
	}
};

export default {
	setItem,
	getItem,
	removeItem,
};

const sessionData = {};
let isSessionStorageSupport = true;

export const detectSessionStorageSupport = () => {
	try {
		window.sessionStorage.setItem('test', '1');
		window.sessionStorage.removeItem('test');
	} catch (e) {
		console.warn('Does not support sessionStorage', e);
		isSessionStorageSupport = false;
	}
};

const setSessionItem = (key, value) => {
	const prefixKey = prefix(key);

	if (isSessionStorageSupport) {
		window.sessionStorage.setItem(prefixKey, value);
		return;
	}

	sessionData[prefixKey] = value;
};

const getSessionItem = key => {
	const prefixKey = prefix(key);

	if (isSessionStorageSupport) {
		return window.sessionStorage.getItem(prefixKey);
	}

	if (Object.hasOwnProperty.call(sessionData, prefixKey)) {
		return sessionData[prefixKey];
	}

	return null;
};

const removeSessionItem = key => {
	const prefixKey = prefix(key);

	if (isSessionStorageSupport) {
		window.sessionStorage.removeItem(prefixKey);
		return;
	}

	if (Object.hasOwnProperty.call(sessionData, prefixKey)) {
		delete sessionData[prefixKey];
	}
};

export const sessionStorage = {
	setItem: setSessionItem,
	getItem: getSessionItem,
	removeItem: removeSessionItem,
};



// WEBPACK FOOTER //
// ./src/util/storage.js